module.exports = __webpack_public_path__ + "static/media/admin_canvas_pocket_icon.216410dd.svg";